import  { KeyboardEvent } from 'react';
import styles from './ClickableEmoji.module.css';

interface ClickableEmojiProps {
  emoji: string;
  isSelected: boolean; // Make this required since we're always using it in a controlled manner
  onClick?: (emoji: string) => void;
  ariaLabel: string;
  label?: string;
  title?: string;
}

export function ClickableEmoji({ emoji, isSelected, onClick, ariaLabel, label, title }: ClickableEmojiProps) {
  // Handle click event
  const handleClick = () => {
    // Call external onClick handler if provided
    if (onClick) {
      onClick(emoji);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <div className={label ? 'flex flex-col items-center' : ''}>
      <div
        className={`${styles.emojiContainer} ${isSelected ? styles.selected : ''}`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={ariaLabel}
        aria-pressed={isSelected}
        title={title}
      >
        <span className={styles.emoji}>
          <span className={styles.emojiCharacter}>{emoji}</span>
        </span>
        <svg className={styles.checkmarkIcon} viewBox="0 0 16 16" aria-hidden="true">
          <circle cx="8" cy="8" r="8" fill="#007bff" />
          <path
            d="M4.5 8.5 L7 11 L11.5 5.5"
            stroke="white"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {label && (
        <span className="text-[10px] text-gray-500 dark:text-gray-400 -mt-2 select-none">{label}</span>
      )}
    </div>
  );
}